import { render, staticRenderFns } from "./AMSStaffSelector.vue?vue&type=template&id=396fdb24&scoped=true&"
import script from "./AMSStaffSelector.vue?vue&type=script&lang=ts&"
export * from "./AMSStaffSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AMSStaffSelector.vue?vue&type=style&index=0&id=396fdb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396fdb24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VDataTable,VFlex,VLayout,VSelect,VTextField})
